/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} German_Level_LabelInputs */

const en_german_level_label = /** @type {(inputs: German_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German level`)
};

const de_german_level_label = /** @type {(inputs: German_Level_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutschkenntnisse`)
};

/**
* | output |
* | --- |
* | "German level" |
*
* @param {German_Level_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const german_level_label = /** @type {((inputs?: German_Level_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<German_Level_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_german_level_label(inputs)
	return en_german_level_label(inputs)
});